import Vue from 'vue';
import Vuex from 'vuex';
import VueMoment from 'vue-moment';
import lodash from 'lodash';
import VueLodash from "vue-lodash";
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import VueClipboard from 'vue-clipboard2';
import VueJivosite from 'vue-jivosite';
import Framework7 from "framework7/framework7.esm.bundle";
import Framework7Vue from "framework7-vue/framework7-vue.esm.bundle";
import App from './App.vue'

import { store } from './store';

Framework7.use(Framework7Vue);

import 'framework7/framework7.bundle.less';
import 'framework7-icons';
import '@/assets/css/app.css';
import '@/assets/css/style.css';
import '@/assets/css/custom.less';
import './registerServiceWorker'

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueMoment);
Vue.use(VueLodash, { lodash: lodash });
Vue.use(vueNumeralFilterInstaller);
Vue.use(VueJivosite, { widgetId: 'eGRMO3ji4w', initialView: false });

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.filter('uppercase', (value) => {
    return value.toString().toUpperCase();
});

Vue.filter('strip_tags', (string) => {
    return string.replace(/<\/?[^>]+>/ig, " ");
});

Vue.mixin({
    methods: {
        title_play_style(region, play_style) {
            let result = '';
            if (region === 'mn') {
                result = 'MIỀN NAM'
                switch(play_style){
                    case 'mn_mtay':
                        result = 'MN - M.TÂY'
                        break;
                    case 'mn_buonme':
                        result = 'MN - BUÔN MÊ'
                        break;
                }
            }
            else if (region === 'mb') {
                result = 'MIỀN BẮC';
                switch(play_style){
                    case 'mb_mtay':
                        result = 'MB - M.TÂY'
                        break;
                    case 'mb_ngan':
                        result = 'MB - NGHỆ AN'
                        break;
                    case 'mb_hanoi':
                        result = 'MB - HÀ NỘI'
                        break;
                  case 'mb_buonme':
                        result = 'MB - BUÔN MÊ'
                        break;
                }
            }
            else if (region === 'mt') {
                result = 'MIỀN TRUNG';
                switch(play_style){
                    case 'mt_mtay':
                        result = 'MT - M.TÂY'
                        break;
                    case 'mt_buonme':
                        result = 'MT - BUÔN MÊ'
                        break;
                }
            }
            return result;
        }, command_play_style(command, play_style) {
            let result = command;
            if (play_style === 'mb_ngan') {
                switch(command){
                    case '1C':
                        result = 'Ngang'
                        break;
                    case '2CB':
                        result = 'Lô'
                        break;
                    case '2CĐ':
                        result = 'Đề'
                        break;
                    case '3CXC':
                        result = '3Càng'
                        break;
                    case 'ĐáX2':
                        result = 'Xiên2'
                        break;
                    case 'ĐáX3':
                        result = 'Xiên3'
                        break;
                    case 'ĐáX4':
                        result = 'Xiên4'
                        break;
                }
            }
            else if (play_style === 'mb_hanoi') {
              switch(command){
                case 'GNhat':
                  result = 'GNhất'
                  break;
                case '2CB':
                  result = 'Lô'
                  break;
                case '2CĐ':
                  result = 'Đề'
                  break;
                case '3CXC':
                  result = 'Càng'
                  break;
                case 'ĐáX2':
                  result = 'Xi2'
                  break;
                case 'ĐáX3':
                  result = 'Xi3'
                  break;
                case 'ĐáX4':
                  result = 'Xi4'
                  break;
              }
            }
            else if (play_style === 'mn_buonme' || play_style === 'mt_buonme' || play_style === 'mb_buonme') {
                switch(command){
                    case '2CB':
                        result = '2CLô'
                        break;
                    case '2CĐ':
                        result = '2CDKC'
                        break;
                    case '3CB':
                        result = '3CLô'
                        break;
                    case '3CXC':
                        result = '3CKDB'
                        break;
                }
            }
            return result;
        }, removeVnString(str) {
            str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
            str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
            str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
            str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
            str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
            str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
            str = str.replace(/đ/g, "d");
            str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
            str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
            str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
            str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
            str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
            str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
            str = str.replace(/Đ/g, "D");
            str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, "");
            str = str.replace(/\u02C6|\u0306|\u031B/g, "");
            str = str.replace(/ + /g, " ");
            str = str.trim();

            return str;
        }, localParse(originalMessage) {
            let content = originalMessage.replace(/(O)/g, '0');

            content = content.trim();
            content = content.toLowerCase();

            content = this.removeVnString(content);

            content = content.replace(/(dacheo|dvcheo|daxien)/g, 'dx');
            content = content.replace(/(<br>|<br\/>)/g, ' ');
            content = content.replace(/(\d+)[\.\,](\d)(n?)(?![0-9])/g, '$1;;cham;;$2$3');

            content = content.replace(/(hochiminh|thanh pho|thanhpho|ho chi minh|saigon|sai gon|sg|tphcm)/g, 'tp');
            content = content.replace(/(dongthap|dong thap|dthap)/g, 'dt');
            content = content.replace(/(camau|ca mau)/g, 'cm');
            content = content.replace(/(vungtau|vung tau|vtau)/g, 'vt');
            content = content.replace(/(baclieu|bac lieu|blieu|bacliu|bac liu|bliu)/g, 'bli');
            content = content.replace(/(dongnai|dong nai|dnai)/g, 'dn');
            content = content.replace(/(cantho|can tho|ctho)/g, 'ct');
            content = content.replace(/(soctrang|soc trang|strang)/g, 'st');
            content = content.replace(/(tayninh|tay ninh|tninh)/g, 'tn');
            content = content.replace(/(angiang|an giang|agiang)/g, 'ag');
            content = content.replace(/(bentre|ben tre|btre)/g, 'bt');
            content = content.replace(/(ninhthuan|ninh thuan|nthuan)/g, 'nt');
            content = content.replace(/(binhthuan|binh thuan|bthuan|thuan)/g, 'bth');
            content = content.replace(/(vinhlong|vinh long|vlong)/g, 'vl');
            content = content.replace(/(binhduong|binh duong|bduong|bduog|songbe|song be)/g, 'bd');
            content = content.replace(/(travinh|tra vinh|tvinh)/g, 'tv');
            content = content.replace(/(longan|long an)/g, 'la');
            content = content.replace(/(binhphuoc|binh phuoc|bphuoc)/g, 'bp');
            content = content.replace(/(haugiang|hau giang|hgiang|hgiag)/g, 'hg');
            content = content.replace(/(tiengiang|tien giang|tgiang|tgiag)/g, 'tg');
            content = content.replace(/(kiengiang|kien giang|kgiang|kgiag)/g, 'kg');
            content = content.replace(/(dalat|da lat)/g, 'dl');
            content = content.replace(/(daklak|daklac)/g, 'dl');
            content = content.replace(/(danang|da nang|danag)/g, 'dn');
            content = content.replace(/(binhdinh|binh dinh|bdinh)/g, 'bd');
            content = content.replace(/(phuyen|phu yen|puyen)/g, 'py');
            content = content.replace(/(khanhhoa|khanh hoa|k\.hoa)/g, 'kh');
            content = content.replace(/(quangngai|quang ngai|qngai)/g, 'qn');
            content = content.replace(/(quangbinh|quang binh|qbinh)/g, 'qb');
            content = content.replace(/(daknong|dak nong|dnong)/g, 'dno');

            content = content.replace(/(2dai|2 dai|hai dai|haidai)/g, '2d');
            content = content.replace(/(3dai|3 dai|ba dai|badai)/g, '3d');
            content = content.replace(/(4dai|4 dai|bon dai|bondai)/g, '4d');
            content = content.replace(/(daiphu|dai phu|dphu)/g, 'dp');
            content = content.replace(/(daichinh|dai chinh|dchinh)/g, 'dc');

            content = content.replace(/(keokhonggiap|khonggiap|keokogiap|kogiap)/g, '00kkg99');
            content = content.replace(/(keocongiap|keogiap|giap)/g, '00kg99');
            content = content.replace(/(keochanle|kchanle|chanle|chan le)/g, '00kcl99');
            content = content.replace(/(keolechan|klechan|lechan|le chan)/g, '00klc99');
            content = content.replace(/(keochanchan|kchanchan|chanchan|chan chan)/g, '00kcc99');
            content = content.replace(/(keolele|klele|lele|le le)/g, '00kll99');
            content = content.replace(/(keochan|kchan)/g, '00kc99');
            content = content.replace(/(keole|kle)/g, '00kl99');

            content = content.replace(/(^|\s|\.|\,)(tin|t)\s*\d+\s*/g, ' ');
            content = content.replace(/([a-zA-Z]+)(?!he)(\d+)/g, '$1 $2');

            content = content.replace(/(da xien|da vong|d xien|d vong|dvong|da v)/g, 'dx');
            content = content.replace(/(^hn|\shn)\s/g, ' ');

            content = content.replace(/(mien bac|mienbac|mbac|ha noi|hanoi|mb|mien nam|miennam|mnam|mn|mien trung|mientrung|mtrung|mt)/g, '');

            content = content.replace(/[^a-zA-Z0-9\s;@]/g, ' ');
            content = content.replace(/;;cham;;(\d+)(n?)/g, '.$1$2');
            content = content.replace(/(\d*\.?\d*)n(\s|$)/g, '$1n ');
            content = content.replace(/\s+/g, ' ');

            content = content.replace(/(\d+)\s*(nghin|ngan|n)/g, '$1n');
            content = content.trim();
            content = content.replace(/\n+/g, ' ');


            content = this.parseCommands(content, ['bao', 'baolo', 'blo', 'b', 'lo', 'bl']);
            content = this.parseCommands(content, ['baodao', 'daobao', 'baolodao', 'bldao', 'bdao', 'lodao', 'daolo', 'bld', 'daob', 'db']);
            content = this.parseCommands(content, ['duoidao', 'daoduoi', 'duidao', 'daodui']);
            content = this.parseCommands(content, ['xcdau', 'xdau', 'xchudau', 'xiuchudau', 'tldau', 'xiudau', 'tldau', 'tlodau', 'dauxiu', 'dautl', 'daux', 'dauxc', 'dauxiuchu', 'dautlo']);
            content = this.parseCommands(content, ['davong', 'dav', 'dv', 'da']);
            content = this.parseCommands(content, ['dathang', 'thang', 'dath', 'dat']);
            content = this.parseCommands(content, ['dxvong', 'daxien', 'dacv', 'daxv', 'davx', 'dacx', 'daxc', 'dac', 'dxv', 'dxi', 'dvx', 'dax', 'xien', 'xi', 'dcv', 'dx']);
            content = this.parseCommands(content, ['dxdao_432', 'xq', 'xiq', 'xiquay', 'xienquay', 'xquay', 'xiendao', 'daoxien', 'xidao', 'daoxi']);
            content = this.parseCommands(content, ['dxdao_2', 'xienhai', 'xihai', 'daxienhai', 'dxhai', 'daxhai', 'xien2', 'xi2', 'lx2']);
            content = this.parseCommands(content, ['dxdao_3', 'xienba', 'xiba', 'daxienba', 'dxba', 'daxba', 'xien3', 'xi3', 'lx3']);
            content = this.parseCommands(content, ['dxdao_4', 'xienbon', 'xibon', 'daxienbon', 'dxbon', 'daxbon', 'xien4', 'xi4', 'lx4']);
            content = this.parseCommands(content, ['dauduoi', 'daudui', 'dduoi', 'ddui', 'dd']);
            content = this.parseCommands(content, ['dau']);
            content = this.parseCommands(content, ['dacbiet', 'duoi', 'dui', 'de']);
            content = this.parseCommands(content, ['btam', 'tamlo', 'btamlo', 'baotam', 'baotamlo']);
            content = this.parseCommands(content, ['xdaudao', 'xiudaudao', 'xcdaudao', 'xchudaudao', 'tldaudao', 'tlodaudao', 'dauxiudao', 'dautldao', 'xiuchudaudao', 'dauxdao', 'dauxcdao', 'dauxiuchudao', 'dautloda', 'dautlodao']);
            content = this.parseCommands(content, ['xduoi', 'xdui', 'xcduoi', 'xcdui', 'xiuduoi', 'xiudui', 'xiuchuduoi', 'xiuchudui', 'tlduoi', 'tldui', 'tloduoi', 'tlodui', 'duoixiu', 'duixiu', 'duoitl', 'duitl', 'duoitlo', 'duitlo', 'xchuduoi', 'xchudui', 'duoix', 'duix', 'duoixc', 'duixc', 'duoixiuchu', 'duixiuchu', 'bacang', 'bac', 'cang']);
            content = this.parseCommands(content, ['xduoidao', 'xduidao', 'xcduidao', 'xcduoidao', 'xiuduidao', 'xiuduoidao', 'xiuchuduoidao', 'xiuchuduidao', 'tlduoidao', 'tlduidao', 'tloduoidao', 'duoixiudao', 'duixiudao', 'duoitldao', 'duitldao', 'duoixiudao', 'duixiudao', 'duoixdao', 'duixdao', 'duoixcdao', 'duixcdao', 'duoixiuchudao', 'duixiuchudao', 'xchuduidao', 'xchuduoidao']);
            content = this.parseCommands(content, ['xcdao', 'xdao', 'xchudao', 'xiudao', 'xiuchudao', 'tieulodao', 'tlodao', 'tldao', 'xd', 'xcd', 'tld', 'td', 'dxc', 'daoxc', 'dtl', 'daox']);
            content = this.parseCommands(content, ['xc', 'xchu', 'xiuchu', 'xiu', 'xieu', 'tieulo', 'tlo', 'x', 'tl']);
            content = this.parseCommands(content, ['baylo', 'bay', 'baobaylo', 'bbaylo']);
            content = this.parseCommands(content, ['baylodao', 'baydao', 'baobaylodao', 'bbaylodao']);
            content = this.parseCommands(content, ['ngang', 'namso']);
            content = this.parseCommands(content, ['van', 'ngan', 'tram', 'tong', 'dan', 'dinh', 'cham', 'cap']);
            content = this.parseCommands(content, ['dau', 'chuc']);
            content = this.parseCommands(content, ['duoi', 'dui', 'dit', 'vi']);
            content = this.parseCommands(content, ['kep', 'bang', 'sat', 'lech', 'am', 'chan', 'le', 'cao', 'thap']);
            content = this.parseCommands(content, ['k', 'den', 'keo', 'khc', 'kht', 'khn', 'kc', 'kl', 'kcc', 'kll', 'kcl', 'klc', 'kg', 'kkg']);
            content = this.parseCommands(content, ['keolon', 'klon', 'keotai', 'ktai', 'keonho', 'knho', 'keoxiu', 'kxiu', 'keolonlon', 'klonlon', 'lonlon', 'keotaitai', 'ktaitai', 'taitai', 'keonhonho', 'knhonho', 'nhonho', 'keoxiuxiu', 'kxiuxiu', 'xiuxiu', 'keolonnho', 'klonnho', 'lonnho', 'keotaixiu', 'ktaixiu', 'taixiu', 'keonholon', 'knholon', 'nholon', 'keoxiutai', 'kxiutai', 'xiutai', 'chanchan', 'lele', 'chanle', 'lechan', 'chan', 'le', 'caocao', 'thapthap', 'caothap', 'thapcao', 'cao', 'thap', 'tongchan', 'tongle', 'tongcao', 'tongthap']);

            content = content.replace(/(?=(2d|3d|4d))\s*(\d+)n?\s*d\s*(\d+)n?\s*d\s*(\d+)n?/g, ' $2 dau $3n duoi $4n ');
            content = content.replace(/(?!(2d|3d|4d))\s*(\d{2,}\.?\d?)n?\s*d\s*(\d+\.?\d?)n?\s*d\s*(\d+\.?\d?)n?/g, ' $2 dau $3n duoi $4n ');
            content = content.replace(/(\d{2,})\.{1,}(\d{2,})\s+/g, ' $1 $2 ');

            content = this.parseChannels(content, ['hcm', 'tpho', 'tph', 'dth', 'cmau', 'cma', 'btr', 'btre', 'vtau', 'vta', 'bli', 'bliu', 'blie', 'dnai', 'dna', 'cth', 'ctho', 'str', 'bth', 'tni', 'agi', 'vlo', 'sb', 'bdu', 'bdg', 'sbe', 'tvi', 'tgi', 'kgi', 'dla', 'dlat', 'lan', 'bph', 'hgi', 'tp', 'dt', 'cm', 'vt', 'bli', 'dn', 'ct', 'st', 'tn', 'ag', 'bt', 'vl', 'bd', 'tv', 'la', 'bp', 'hg', 'tg', 'kg', 'dl']);
            content = this.parseChannels(content, ['mb', 'hn']);
            content = this.parseChannels(content, ['hue', 'tth', 'dlk', 'qnm', 'dng', 'bdi', 'dng', 'qng', 'dlac', 'dlak', 'dna', 'glai', 'ktum', 'qnam', 'qna', 'khoa', 'qtri', 'qtr', 'nth', 'qbi', 'pyen', 'hu', 'tt', 'th', 'py', 'dl', 'qn', 'kh', 'bd', 'qt', 'qn', 'gl', 'nt', 'qn', 'dn', 'dno', 'kt', 'qb']);
            content = this.parseChannels(content, ['2d', '3d', '4d']);
            content = this.parseChannels(content, ['dc', 'dp', 'dp2', 'dp3', 'phu', 'dphu', 'ch', 'chanh', 'chinh']);

            content = this.parseCombined(content, ['hcm', 'tpho', 'tph', 'dth', 'cmau', 'cma', 'btr', 'btre', 'vtau', 'vta', 'bli', 'bliu', 'blie', 'dnai', 'dna', 'cth', 'ctho', 'str', 'bth', 'tni', 'agi', 'vlo', 'sb', 'bdu', 'bdg', 'sbe', 'tvi', 'tgi', 'kgi', 'dla', 'dlat', 'lan', 'bph', 'hgi', 'tp', 'dt', 'cm', 'vt', 'bli', 'dn', 'ct', 'st', 'tn', 'ag', 'bt', 'vl', 'bd', 'tv', 'la', 'bp', 'hg', 'tg', 'kg', 'dl', 'hue', 'tth', 'dlk', 'qnm', 'dng', 'bdi', 'dng', 'qng', 'dlac', 'dlak', 'dna', 'glai', 'ktum', 'qnam', 'qna', 'khoa', 'qtri', 'qtr', 'nth', 'qbi', 'pyen', 'hu', 'tt', 'th', 'py', 'dl', 'qn', 'kh', 'bd', 'qt', 'qn', 'gl', 'nt', 'qn', 'dn', 'dno', 'kt', 'qb', 'mb', 'hn', '2d', '3d', '4d', 'dc', 'dp', 'dp2', 'dp3', 'phu', 'dphu', 'ch', 'chanh', 'chinh']);

            content = content.replace(/;\s*;/g, ';');
            content = content.replace(/;/g, ' ; ');
            content = content.replace(/(b\s+7\s+lo)\s+(\d+)*/g, 'baylo $2');
            content = content.replace(/(\d{2})(\d{2})(\d{2})(\d{2})\s*(dat|dx)/g, '$1 $2 $3 $4 $5');
            content = content.replace(/(\d{2})(\d{2})(\d{2})\s*(dat|dx)/g, '$1 $2 $3 $4');
            content = content.replace(/(\d{2})(\d{2})\s*(dat|dx)/g, '$1 $2 $3');

            content = content.replace(/\s+/g, ' ').trim();

            return content;
        }, sortByLength(array) {
            return array.sort((x, y) => y.length - x.length);
        }, parseCommands(content, commands) {
            let commands_string = (this.sortByLength(commands)).join('|');

            content = content.replace(new RegExp(`(\\d+)(${commands_string})\\s+`, 'g'), '$1 $2 ');
            content = content.replace(new RegExp(`(\\d+)(${commands_string})(\\d+)`, 'g'), '$1 $2 $3');
            content = content.replace(new RegExp(`(\\d+)n(${commands_string})`, 'g'), '$1n $2 ');

            content = content.replace(/\sb\st\s/g, ' bt ');
            content = content.replace(new RegExp(`\\s(${commands_string})(\\d+)n`, 'g'), ' $1 $2n');

            return content;
        }, parseChannels(content, channels) {
            let channels_string = (this.sortByLength(channels)).join('|');

            content = content.replace(new RegExp(`(\\d+)n(${channels_string})`, 'g'), '$1n $2 ');
            content = content.replace(new RegExp(`(\\d+)(${channels_string})`, 'g'), '$1 $2 ');

            return content;
        }, parseCombined(content, arrayCombined, stickTogether = false) {
            let generatedCombinedArray = this.generateCoupleOfAny(arrayCombined);
            generatedCombinedArray.forEach(item => {
                if (stickTogether) {
                    content = content.replace(new RegExp(`/(${item[0]}) (${item[0]})/`, 'g'), '$1$2');
                    content = content.replace(new RegExp(`/(${item[0]}) (${item[1]})/`, 'g'), '$1$2');
                    content = content.replace(new RegExp(`/(${item[1]}) (${item[0]})/`, 'g'), '$1$2');
                }
                else{
                    content = content.replace(new RegExp(`/(${item[0]})(${item[0]})/`, 'g'), '$1 $2');
                    content = content.replace(new RegExp(`/(${item[0]})(${item[1]})/`, 'g'), '$1 $2');
                    content = content.replace(new RegExp(`/(${item[1]})(${item[0]})/`, 'g'), '$1 $2');
                }
            });
            return content;
        }, generateCoupleOfAny(arr) {
            let result = [];
            for(let i = 0 ; i < arr.length ; i++){
                for(let j = i + 1 ; j < arr.length ; j++){
                    if (typeof arr[i] !== 'undefined' && typeof arr[j] !== 'undefined') {
                        result.push([arr[i], arr[j]]);
                    }
                }
            }
            return result;
        }
    }
})

window.myApp = new Vue({
    render: h => h(App), store
}).$mount('#app')
